export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";